import { LolloBernie as LolloBernie$2 } from './LolloBernie.style.js';
import { jsx } from 'react/jsx-runtime';

var LolloBernie = function LolloBernie(_ref) {
  var _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy;
  return /*#__PURE__*/jsx(LolloBernie$2, {
    src: "https://idun.nltg.com/assets/images/L&B.png",
    alt: "lollo&bernie",
    loading: lazy ? 'lazy' : 'eager'
  });
};
var LolloBernie$1 = LolloBernie;

export { LolloBernie$1 as default };
//# sourceMappingURL=LolloBernie.js.map
